// Add all JS development here
jQuery(function ($) {
	$(document).ready(function () {

		(function () {

			// Check if Owl Carousel is loaded
			if (typeof $.fn.owlCarousel === 'undefined') {
				console.error('Owl Carousel is not loaded! Please include owl.carousel.min.js');
				return;
			}

			// Initialize Home Hero Slider
			if ($(".home-slider").length > 0) {

				$(".home-slider").owlCarousel({
					loop: true,
					margin: 0,
					nav: false,
					dots: true,
					items: 1,
					autoplay: true,
					autoplayTimeout: 2000,
					autoplayHoverPause: true,
					smartSpeed: 600,
					mouseDrag: true,
					touchDrag: true,
					pullDrag: false,
					freeDrag: false,
					responsive: {
						0: {
							items: 1,
							nav: false,
							dots: true
						},
						600: {
							items: 1,
							nav: false,
							dots: true
						},
						1000: {
							items: 1,
							nav: false,
							dots: true
						},
					},
					onInitialized: function (event) {
						$('.home-slider .owl-nav').hide();
						addKeyboardNavigation();
					}
				});

				// Keyboard navigation
				function addKeyboardNavigation() {
					$(document).on('keydown', function (e) {
						if ($('.home-slider').is(':visible')) {
							switch (e.which) {
								case 37: // Left arrow
									$('.home-slider').trigger('prev.owl.carousel');
									break;
								case 39: // Right arrow
									$('.home-slider').trigger('next.owl.carousel');
									break;
							}
						}
					});
				}

				// Touch/swipe handling
				let startX = 0;
				let endX = 0;
				let startY = 0;
				let endY = 0;

				$('.home-slider').on('touchstart', function (e) {
					startX = e.originalEvent.touches[0].clientX;
					startY = e.originalEvent.touches[0].clientY;
				});

				$('.home-slider').on('touchend', function (e) {
					endX = e.originalEvent.changedTouches[0].clientX;
					endY = e.originalEvent.changedTouches[0].clientY;

					const diffX = startX - endX;
					const diffY = startY - endY;

					// Check if horizontal swipe is more significant than vertical
					if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
						if (diffX > 0) {
							$('.home-slider').trigger('next.owl.carousel');
						} else {
							$('.home-slider').trigger('prev.owl.carousel');
						}
					}
				});

				// Pause on hover
				$('.home-slider').hover(
					function () {
						$(this).trigger('stop.owl.autoplay');
					},
					function () {
						$(this).trigger('play.owl.autoplay');
					}
				);
			}


		})();

		var accordion = $(".accordion");
		accordion.on("click", function () {
			var $this = $(this);
			accordion.removeClass("active");
			accordion.find(".fade").removeClass("active");
			$this.addClass("active");
			setTimeout(function () {
				$this.find(".fade").addClass("active");
			}, 1000);
		});

		// <- Carousel functions ->
		(function () {
			// Single service page carousel
			$(".service-img-carousel").owlCarousel({
				loop: true,
				autoplay: true,
				margin: 15,
				nav: true,
				navText: [
					"<div class='prev-slide'><i class='ri-arrow-left-line'></i></div>",
					"<div class='next-slide'><i class='ri-arrow-right-line'></i></div>",
				],
				dots: false,
				responsive: {
					0: {
						items: 1,
					},
					600: {
						items: 2,
					},
					1000: {
						items: 2,
					},
				},
			});

			// Hide Offcanvace when click nav link
			$("#mobileMenu a.nav-link").on("click", function () {
				$("#mobileMenu").offcanvas("hide");
			});

			//Price Table Toggle
			$("#js-contcheckbox").change(function () {
				if (this.checked) {
					$(".js-montlypricing").css("display", "none");
					$(".js-yearlypricing").css("display", "block");
					$(".afterinput").addClass("text-color");
					$(".beforeinput").removeClass("text-color");
				} else {
					$(".js-montlypricing").css("display", "block");
					$(".js-yearlypricing").css("display", "none");
					$(".afterinput").removeClass("text-color");
					$(".beforeinput").addClass("text-color");
				}
			});

			$(".testimonial-slider").owlCarousel({
				loop: true,
				margin: 10,
				nav: false,
				dots: false,
				responsive: {
					0: {
						items: 1,
					},
					600: {
						items: 3,
					},
					1000: {
						items: 1,
					},
				},
			});

			$(".home-project-slider").owlCarousel({
				loop: true,
				margin: 50,
				nav: true,
				navText: [
					"<div class='prev-slide'><i class='ri-arrow-left-line'></div>",
					"<div class='next-slide'><i class='ri-arrow-right-line'></i></div>",
				],
				dots: false,
				responsive: {
					0: {
						items: 1,
					},
					600: {
						items: 3,
					},
					1000: {
						items: 3,
					},
				},
			});

			$(".feedback-slider").owlCarousel({
				loop: true,
				margin: 50,
				nav: false,
				dots: true,
				responsive: {
					0: {
						items: 1,
					},
					600: {
						items: 2,
					},
					1000: {
						items: 2,
					},
				},
			});

			$(".client-slider").owlCarousel({
				loop: true,
				margin: 50,
				nav: false,
				dots: true,
				responsive: {
					0: {
						items: 1,
					},
					600: {
						items: 3,
					},
					1000: {
						items: 5,
					},
				},
			});

			// $('.thinking-slider').owlCarousel({
			//   loop: true,
			//   margin: 50,
			//   nav: false,
			//   dots: false,
			//   responsive: {
			//     0: {
			//       items: 1
			//     },
			//     600: {
			//       items: 3
			//     },
			//     1000: {
			//       items: 3
			//     }
			//   }
			// });

			$(".slider-for").slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				// fade: true,
				asNavFor: ".slider-nav",
			});
			$(".slider-nav").slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				asNavFor: ".slider-for",
				dots: false,
				arrows: false,
				centerMode: false,
				focusOnSelect: true,
				responsive: [
					{
						breakpoint: 375,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				],
			});
		})();



		// <- Other functions ->
		(function () {
			// Fixed nav bar
			var lastScrollTop = 0,
				navbar = $(".navbar");
			var navbarHeight = navbar.outerHeight();

			$(window).on("scroll", function () {
				var currentScroll = $(this).scrollTop();

				navbar
					.toggleClass(
						"navbar-hidden",
						currentScroll > lastScrollTop && currentScroll > navbarHeight
					)
					.toggleClass(
						"navbar-visible",
						currentScroll <= lastScrollTop || currentScroll <= navbarHeight
					)
					.toggleClass("scrolled", currentScroll > navbarHeight);

				lastScrollTop = currentScroll;
			});
		})();

		// <-- Filter functions -->
		(function () {
			// Projects custom post archive page post filter functions - start
			/**
			 * Function: initializeTaxonomyFilter(options).
			 * Description: filter dunction.
			 * Returns: initializeTaxonomyFilter(options).
			 */

			function initializeTaxonomyFilter(options) {
				var postsPerPage = options.postsPerPage || 5;
				var visiblePages = options.visiblePages || 5;
				var urlUpdate =
					options.urlUpdate !== undefined ? options.urlUpdate : true;
				var ajaxAction =
					options.ajaxAction || "get_posts_by_multiple_taxonomies";
				var containerSelector = options.containerSelector || "#posts-container";
				var paginationSelector = options.paginationSelector || "#pagination";
				var taxonomySelector = options.taxonomySelector || ".taxonomy-select";
				var searchInputSelector =
					options.searchInputSelector || "#search-input";
				var sortOrderSelector = options.sortOrderSelector || ".sort-order";
				var clearFiltersSelector =
					options.clearFiltersSelector || ".clear-filters";
				var dateRangeEnable =
					options.dateRangeEnable !== undefined
						? options.dateRangeEnable
						: true;
				var getPostCount = options.getPostCount || ".post-count";
				var dateRangeInputId = options.dateRangeInputId || "blog-date-range";

				// Date picker thing start
				if (dateRangeEnable) {
					var dateRangeElement = document.getElementById(dateRangeInputId);

					// Check if the date range element exists
					if (dateRangeElement) {
						var picker = new Litepicker({
							element: dateRangeElement,
							format: "YYYY-MM-DD",
							singleMode: false,
							autoApply: true,
						});

						var dateSelectionCompleted = false;

						picker.on("selected", function (start, end) {
							// Reset the flag
							dateSelectionCompleted = false;

							// Wait a small amount of time to allow the user to select both dates
							if (picker.getStartDate() && picker.getEndDate()) {
								dateSelectionCompleted = true;
								fetchPosts(1); // Fetch posts if both dates are selected
							}

							// After selecting date range, check if any filters are selected
							checkFiltersSelected();
						});
					}
				}
				// Date picker thing end

				function checkFiltersSelected() {
					var filterSelected = false;
					$(taxonomySelector).each(function () {
						if ($(this).val() !== "all") {
							filterSelected = true;
						}
					});

					if ($(searchInputSelector).val() !== "") {
						filterSelected = true;
					}

					// Check if date range is selected
					if (
						dateRangeEnable &&
						picker &&
						picker.getStartDate() &&
						picker.getEndDate()
					) {
						filterSelected = true;
					}

					if (filterSelected) {
						$(clearFiltersSelector).show();
					} else {
						$(clearFiltersSelector).hide();
					}
				}

				function clearFilters() {
					$(taxonomySelector).val("all");
					$(searchInputSelector).val("");
					// Reset the date picker if dateRangeEnable is true
					if (dateRangeEnable && picker) {
						picker.clearSelection();
					}
					updateActiveClassOnSelect();
					updateParentClassOnChildSelect();
					fetchPosts(1);
					checkFiltersSelected(); // Recheck filters and update the button visibility
				}

				$(
					taxonomySelector +
					", " +
					searchInputSelector +
					", " +
					sortOrderSelector
				).on("change keyup", function () {
					checkFiltersSelected();
					fetchPosts(1);
				});

				$(clearFiltersSelector).on("click", function () {
					clearFilters();
				});

				$(
					taxonomySelector +
					", " +
					searchInputSelector +
					", " +
					sortOrderSelector
				).on("change keyup", function () {
					fetchPosts(1);
				});

				function updateUrlWithFilters(selectedTerms, page) {
					// Check if filter elements exist on the page
					if (urlUpdate && $(taxonomySelector).length > 0) {
						var params = $.param(selectedTerms) + "&page=" + page;
						history.pushState(null, null, "?" + params);
					}
				}

				function applyFiltersFromUrl() {
					var urlParams = new URLSearchParams(window.location.search);
					$(taxonomySelector).each(function () {
						var taxonomy = $(this).attr("id").replace("taxonomy-select-", "");
						if (urlParams.has(taxonomy)) {
							$(this).val(urlParams.get(taxonomy));
						}
					});
					var page = urlParams.get("page")
						? parseInt(urlParams.get("page"), 10)
						: 1;
					fetchPosts(page);
				}

				function fetchPosts(page = 1) {
					var selectedTerms = {};
					var sortOrder = $(sortOrderSelector).val();

					// Initialize these variables with default values
					var startDate = "";
					var endDate = "";
					var dateRange = "";

					// Check if picker is defined and then get the dates
					if (dateRangeEnable && typeof picker !== "undefined") {
						startDate = picker.getStartDate()
							? picker.getStartDate().format("YYYY-MM-DD")
							: "";
						endDate = picker.getEndDate()
							? picker.getEndDate().format("YYYY-MM-DD")
							: "";
						dateRange =
							startDate && endDate ? startDate + " to " + endDate : "";
					}

					$(taxonomySelector).each(function () {
						var taxonomy = $(this).attr("id").replace("taxonomy-select-", "");
						var term = $(this).val();
						if (term !== "all") {
							selectedTerms[taxonomy] = term;
						}
					});

					var searchKeyword = $(searchInputSelector).val();

					$(".loading-animation").fadeIn();

					function animatePostLoading(posts) {
						var delay = 0;
						posts.each(function () {
							jQuery(this)
								.css({ opacity: 0 })
								.delay((delay += 100))
								.fadeTo(250, 1);
						});
					}

					$.ajax({
						url: mytheme_ajax_object.ajaxurl,
						type: "POST",
						data: {
							action: ajaxAction,
							selectedTerms: selectedTerms,
							searchKeyword: searchKeyword,
							sortOrder: sortOrder,
							postsPerPage: postsPerPage,
							paged: page,
							date_range: dateRange,
						},
						success: function (response) {
							var data = JSON.parse(response);
							var $postsContainer = $(containerSelector);
							$postsContainer.hide().html(data.posts);

							$(".loading-animation").fadeOut();

							animatePostLoading($postsContainer.children());

							// Animate each post with a delay
							var delayTime = 0;
							$postsContainer.children().each(function () {
								$(this).delay(delayTime).fadeIn(300);
								delayTime += 250; // Increment delay for each post
							});

							$(getPostCount).text("Total Posts: " + data.postCount);
							$postsContainer.show();

							if (data.totalPages > 1) {
								updatePagination(data.totalPages, page);
							} else {
								$(paginationSelector).hide();
							}

							if (urlUpdate) {
								updateUrlWithFilters(selectedTerms, page);
							}
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.error("Error fetching posts:", textStatus, errorThrown);
							$(".loading-animation").fadeOut();
						},
					});
				}

				function updatePagination(totalPages, currentPage) {
					var paginationHtml = "";
					var startPage = Math.max(
						1,
						currentPage - Math.floor(visiblePages / 2)
					);
					var endPage = Math.min(totalPages, startPage + visiblePages - 1);
					startPage = Math.max(
						1,
						Math.min(totalPages - visiblePages + 1, startPage)
					);

					if (currentPage > 1) {
						paginationHtml +=
							'<a href="#" class="page-num" data-page="' +
							(currentPage - 1) +
							'"><i class="ri-arrow-left-s-line"></i></a> ';
					}

					if (startPage > 1) {
						paginationHtml +=
							'<a href="#" class="page-num" data-page="1">1</a> ';
						if (startPage > 2) {
							paginationHtml += "<span>...</span> ";
						}
					}
					for (var i = startPage; i <= endPage; i++) {
						paginationHtml +=
							'<a href="#" class="' +
							(i === currentPage ? "active " : "") +
							'page-num" data-page="' +
							i +
							'">' +
							i +
							"</a> ";
					}
					if (endPage < totalPages) {
						if (endPage < totalPages - 1) {
							paginationHtml += "<span>...</span> ";
						}
						paginationHtml +=
							'<a href="#" class="page-num" data-page="' +
							totalPages +
							'">' +
							totalPages +
							"</a> ";
					}

					if (currentPage < totalPages) {
						paginationHtml +=
							'<a href="#" class="page-num" data-page="' +
							(currentPage + 1) +
							'"><i class="ri-arrow-right-s-line"></i></a>';
					}

					$(paginationSelector).html(paginationHtml).show();

					$(".page-num").on("click", function (e) {
						e.preventDefault();
						var page = $(this).data("page");
						fetchPosts(page);
					});
				}

				function updateActiveClassOnSelect() {
					$(taxonomySelector).each(function () {
						$(this).find("option").removeClass("active");
						$(this).find("option:selected").addClass("active");
					});
				}

				function updateParentClassOnChildSelect() {
					$(taxonomySelector).each(function () {
						$(this).find("option").removeClass("child-selected");
						var selectedOption = $(this).find("option:selected");
						var parentId = selectedOption.data("parent-id");
						if (parentId && parentId !== 0) {
							$(this)
								.find("option")
								.each(function () {
									if ($(this).data("term-id") === parentId) {
										$(this).addClass("child-selected");
									}
								});
						}
					});
				}

				// Event handlers
				$(taxonomySelector).on("change", function () {
					updateActiveClassOnSelect();
					updateParentClassOnChildSelect();
					fetchPosts(1);
				});

				// Initialize
				checkFiltersSelected();
				updateActiveClassOnSelect();
				updateParentClassOnChildSelect();
				applyFiltersFromUrl();
			}

			if ($(".project-archive-page #reportPosts-container").length > 0) {
				// For research and tools
				initializeTaxonomyFilter({
					ajaxAction: "get_filtered_projects_posts",
					containerSelector: "#reportPosts-container",
					paginationSelector: "#reportPagination",
					taxonomySelector: ".taxonomy-select",
					searchInputSelector: "#reportSearch",
					sortOrderSelector: ".Report-sort-order",
					clearFiltersSelector: ".report-clear-filters",
					postsPerPage: 6,
					visiblePages: 5,
					urlUpdate: true,
					dateRangeInputId: "report-date-range",
					getPostCount: ".report-post-count",
				});
			}
			if ($(".blog-archive-page #blog-container").length > 0) {
				// For Blog
				initializeTaxonomyFilter({
					ajaxAction: "get_filtered_blog_posts",
					containerSelector: "#blog-container",
					paginationSelector: "#blogPagination",
					taxonomySelector: ".taxonomy-select",
					searchInputSelector: "#reportSearch",
					sortOrderSelector: ".Blog-sort-order",
					clearFiltersSelector: ".blog-clear-filters",
					postsPerPage: 6,
					visiblePages: 5,
					urlUpdate: true,
					dateRangeInputId: "report-date-range",
					getPostCount: ".blog-post-count",
				});
			}
		})();

		AOS.init({
			duration: 1500,
			once: true,
		});

		// Video Modal Functionality
		const videoModal = document.getElementById("videoModal");
		const videoFrame = document.getElementById("videoFrame");
		const playButton = document.querySelector(".play_button");
		const closeButton = document.querySelector(".close_button");
		const modalOverlay = document.querySelector(".modal_overlay");

		// Open video modal
		function openVideoModal(videoId) {
			const videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
			videoFrame.src = videoUrl;
			videoModal.classList.add("active");
			document.body.style.overflow = "hidden"; // Prevent background scrolling
		}

		// Close video modal
		function closeVideoModal() {
			videoModal.classList.remove("active");
			videoFrame.src = ""; // Stop video playback
			document.body.style.overflow = ""; // Restore scrolling
		}

		// Event listeners
		if (playButton) {
			playButton.addEventListener("click", function () {
				const videoId = this.getAttribute("data-video-id");
				if (videoId) {
					openVideoModal(videoId);
				}
			});
		}

		if (closeButton) {
			closeButton.addEventListener("click", closeVideoModal);
		}

		if (modalOverlay) {
			modalOverlay.addEventListener("click", closeVideoModal);
		}

		// Close modal on Escape key
		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && videoModal.classList.contains("active")) {
				closeVideoModal();
			}
		});

		const filterTabs = document.querySelectorAll(".filter_tabs .nav-link");
		const projectCards = document.querySelectorAll(".project_card");
		const serviceCards = document.querySelectorAll(".service_card");
		const serviceContainers = document.querySelectorAll(".single-service"); // Add this line

		// Function to filter projects with smooth animations (keep as is - working)
		function filterProjects(filterValue) {
			// Your existing project filtering code (working fine)
			const cardsToShow = [];
			const cardsToHide = [];

			projectCards.forEach((card) => {
				const categoriesAttr = card.getAttribute("data-category");
				const categories = categoriesAttr ? categoriesAttr.split(" ") : [];
				const shouldShow = filterValue === "all" || categories.includes(filterValue);

				if (shouldShow && card.classList.contains("filter-hidden")) {
					cardsToShow.push(card);
				} else if (!shouldShow && !card.classList.contains("filter-hidden")) {
					cardsToHide.push(card);
				}
			});

			const masterTL = gsap.timeline();

			if (cardsToHide.length > 0) {
				masterTL.to(cardsToHide, {
					duration: 0.4,
					opacity: 0,
					scale: 0.85,
					y: 30,
					rotationX: 15,
					ease: "power2.in",
					stagger: {
						amount: 0.2,
						from: "random",
					},
					onComplete: () => {
						cardsToHide.forEach((card) => {
							card.style.display = "none";
							card.style.visibility = "hidden";
							card.classList.remove("filter-visible");
							card.classList.add("filter-hidden");
						});
					},
				});
			}

			if (cardsToShow.length > 0) {
				cardsToShow.forEach((card) => {
					card.style.display = "block";
					card.style.visibility = "visible";
					card.classList.remove("filter-hidden");
					card.classList.add("filter-visible");
					gsap.set(card, {
						opacity: 0,
						scale: 0.8,
						y: 50,
						rotationX: -15,
					});
				});

				masterTL.to(
					cardsToShow,
					{
						duration: 0.6,
						opacity: 1,
						scale: 1,
						y: 0,
						rotationX: 0,
						ease: "back.out(1.2)",
						stagger: {
							amount: 0.4,
							from: "start",
						},
					},
					cardsToHide.length > 0 ? 0.2 : 0
				);
			}

			masterTL.to(
				".project_card.filter-visible",
				{
					duration: 0.3,
					scale: 1.02,
					ease: "power2.out",
					yoyo: true,
					repeat: 1,
					stagger: {
						amount: 0.1,
						from: "random",
					},
				},
				"-=0.2"
			);
		}

		// FIXED: Service filtering function - work with containers, not just cards
		function filterServices(filterValue) {
			console.log('Filtering services for:', filterValue);

			const containersToShow = [];
			const containersToHide = [];

			// Work with service containers (.single-service) instead of just cards
			serviceContainers.forEach((container) => {
				const card = container.querySelector('.service_card');
				const categoriesAttr = card ? card.getAttribute("data-category") : "";
				const categories = categoriesAttr ? categoriesAttr.split(" ").filter(cat => cat.trim()) : [];

				console.log('Service categories:', categories, 'Filter:', filterValue);

				const shouldShow = filterValue === "all" || categories.includes(filterValue);

				if (shouldShow && container.classList.contains("filter-hidden")) {
					containersToShow.push(container);
				} else if (!shouldShow && !container.classList.contains("filter-hidden")) {
					containersToHide.push(container);
				}
			});

			console.log('Containers to show:', containersToShow.length, 'to hide:', containersToHide.length);

			// Create master timeline for smooth coordinated animation
			const masterTL = gsap.timeline();

			// First, animate containers that need to be hidden
			if (containersToHide.length > 0) {
				masterTL.to(containersToHide, {
					duration: 0.4,
					opacity: 0,
					scale: 0.85,
					y: 30,
					rotationX: 15,
					ease: "power2.in",
					stagger: {
						amount: 0.2,
						from: "random",
					},
					onComplete: () => {
						containersToHide.forEach((container) => {
							// Hide the entire container, not just the card
							container.style.display = "none";
							container.style.visibility = "hidden";
							container.classList.remove("filter-visible");
							container.classList.add("filter-hidden");
						});
					},
				});
			}

			// Then, animate containers that need to be shown
			if (containersToShow.length > 0) {
				// Prepare containers for animation
				containersToShow.forEach((container) => {
					container.style.display = "block";
					container.style.visibility = "visible";
					container.classList.remove("filter-hidden");
					container.classList.add("filter-visible");
					// Set initial state for animation
					gsap.set(container, {
						opacity: 0,
						scale: 0.8,
						y: 50,
						rotationX: -15,
					});
				});

				// Animate in the new containers
				masterTL.to(
					containersToShow,
					{
						duration: 0.6,
						opacity: 1,
						scale: 1,
						y: 0,
						rotationX: 0,
						ease: "back.out(1.2)",
						stagger: {
							amount: 0.4,
							from: "start",
						},
					},
					containersToHide.length > 0 ? 0.2 : 0
				);
			}

			// Add subtle bounce effect to all visible service containers
			masterTL.to(
				".single-service.filter-visible",
				{
					duration: 0.3,
					scale: 1.02,
					ease: "power2.out",
					yoyo: true,
					repeat: 1,
					stagger: {
						amount: 0.1,
						from: "random",
					},
				},
				"-=0.2"
			);
		}

		// Initialize animations when page loads
		if (typeof gsap !== "undefined") {
			gsap.registerPlugin(ScrollTrigger);

			// Initialize all cards as visible on page load
			serviceCards.forEach(card => {
				card.classList.add("filter-visible");
			});
			projectCards.forEach(card => {
				card.classList.add("filter-visible");
			});
			// IMPORTANT: Initialize service containers as visible too
			serviceContainers.forEach(container => {
				container.classList.add("filter-visible");
			});

			console.log('Filter initialized:', {
				filterTabs: filterTabs.length,
				serviceCards: serviceCards.length,
				projectCards: projectCards.length,
				serviceContainers: serviceContainers.length
			});
		} else {
			console.warn("GSAP not loaded - falling back to CSS animations");
		}

		// Tab click event listeners
		filterTabs.forEach((tab) => {
			tab.addEventListener("click", (e) => {
				e.preventDefault();
				const filterValue = tab.getAttribute("data-filter");

				console.log('Filter clicked:', filterValue);

				// Prevent multiple clicks during animation
				if (tab.classList.contains("filtering")) return;

				// Add filtering state
				filterTabs.forEach((t) => {
					t.classList.remove("active");
					t.classList.add("filtering");
				});

				// Add active class to clicked tab
				tab.classList.add("active");

				// Add subtle animation to the active tab
				if (typeof gsap !== "undefined") {
					gsap.to(tab, {
						duration: 0.3,
						scale: 1.05,
						ease: "power2.out",
						yoyo: true,
						repeat: 1,
					});
				}

				// Filter both projects and services
				if (projectCards.length > 0) {
					filterProjects(filterValue);
				}
				if (serviceContainers.length > 0) {
					filterServices(filterValue);
				}

				// Remove filtering state after animation completes
				setTimeout(() => {
					filterTabs.forEach((t) => t.classList.remove("filtering"));
				}, 1000);
			});
		});
		// How We Work Section Animation
		function initHowWeWorkAnimations() {
			// Company logos sliding animation
			const logosTrack = document.getElementById("logosTrack");
			if (logosTrack && typeof gsap !== "undefined") {
				const logoItems = logosTrack.querySelectorAll(".logo_item");
				const totalWidth = logoItems.length * 280; // Approximate width calculation

				// Set initial position
				gsap.set(logosTrack, { x: 0 });

				// Create infinite sliding animation
				const tl = gsap.timeline({ repeat: -1 });
				tl.to(logosTrack, {
					x: -totalWidth / 2,
					duration: 30,
					ease: "none",
				});

				// Pause on hover
				logosTrack.addEventListener("mouseenter", () => {
					tl.pause();
				});

				// Resume on mouse leave
				logosTrack.addEventListener("mouseleave", () => {
					tl.resume();
				});

				// Individual logo hover effects
				logoItems.forEach((item) => {
					item.addEventListener("mouseenter", () => {
						gsap.to(item, {
							scale: 1.1,
							duration: 0.3,
							ease: "power2.out",
						});
					});

					item.addEventListener("mouseleave", () => {
						gsap.to(item, {
							scale: 1,
							duration: 0.3,
							ease: "power2.out",
						});
					});
				});
			}

			// Work process steps animation
			const processSteps = document.querySelectorAll(".process_step");
			if (processSteps.length > 0 && typeof gsap !== "undefined") {
				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								const step = entry.target;
								const stepIcon = step.querySelector(".step_icon");
								const stepNumber = step.querySelector(".step_number");
								const stepTitle = step.querySelector(".step_title");
								const stepDescription = step.querySelector(".step_description");

								const tl = gsap.timeline();
								tl.from(stepIcon, {
									scale: 0,
									rotation: 180,
									duration: 0.6,
									ease: "back.out(1.7)",
								})
									.from(
										stepNumber,
										{
											opacity: 0,
											y: 20,
											duration: 0.4,
											ease: "power2.out",
										},
										"-=0.3"
									)
									.from(
										stepTitle,
										{
											opacity: 0,
											y: 15,
											duration: 0.4,
											ease: "power2.out",
										},
										"-=0.2"
									)
									.from(
										stepDescription,
										{
											opacity: 0,
											y: 10,
											duration: 0.4,
											ease: "power2.out",
										},
										"-=0.1"
									);

								observer.unobserve(entry.target);
							}
						});
					},
					{
						threshold: 0.3,
					}
				);

				processSteps.forEach((step) => {
					observer.observe(step);
				});
			}
		}

		// Our Skills Section Animation
		function initSkillsAnimations() {
			console.log("Initializing skills animations...");
			const skillsSection = document.querySelector(".our_skills");
			if (!skillsSection) {
				console.log("Skills section not found");
				return;
			}

			const skillItems = skillsSection.querySelectorAll(".skill_item");
			console.log("Found skill items:", skillItems.length);
			const skillsObserved = new Set();

			// Function to animate skill bars and percentages
			function animateSkill(skillItem) {
				console.log("Animating skill item:", skillItem);
				const progressBar = skillItem.querySelector(".skill_progress");
				const percentageElement = skillItem.querySelector(".skill_percentage");
				const targetWidth = parseInt(progressBar.getAttribute("data-width"));
				const targetPercentage = parseInt(
					percentageElement.getAttribute("data-percentage")
				);

				console.log(
					"Target width:",
					targetWidth,
					"Target percentage:",
					targetPercentage
				);

				if (!progressBar || !percentageElement) return;

				// Add animate class for shine effect
				progressBar.classList.add("animate");

				// Always use CSS transition for reliable animation
				progressBar.style.transition = "width 2s cubic-bezier(0.4, 0, 0.2, 1)";
				progressBar.style.width = `${targetWidth}%`;

				// Animate percentage counter
				let currentValue = 0;
				const increment = targetPercentage / 120; // 120 frames for 2 seconds at 60fps
				const timer = setInterval(() => {
					currentValue += increment;
					if (currentValue >= targetPercentage) {
						currentValue = targetPercentage;
						clearInterval(timer);
					}
					percentageElement.textContent = Math.round(currentValue) + "%";
				}, 16.67); // ~60fps

				// Try GSAP if available for smoother animation
				if (typeof gsap !== "undefined") {
					console.log("Using GSAP for animation");
					gsap.to(progressBar, {
						width: `${targetWidth}%`,
						duration: 2,
						ease: "power2.out",
						delay: 0.2,
					});

					// Animate percentage counter with GSAP
					gsap.to(
						{ value: 0 },
						{
							value: targetPercentage,
							duration: 2,
							ease: "power2.out",
							delay: 0.2,
							onUpdate: function () {
								percentageElement.textContent =
									Math.round(this.targets()[0].value) + "%";
							},
						}
					);
				}
			}

			// Intersection Observer for scroll trigger
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting && !skillsObserved.has(entry.target)) {
							console.log("Skill item in view:", entry.target);
							skillsObserved.add(entry.target);

							// Small delay for better visual effect
							setTimeout(() => {
								animateSkill(entry.target);
							}, 100);
						}
					});
				},
				{
					threshold: 0.3,
					rootMargin: "-50px 0px",
				}
			);

			// Observe each skill item
			skillItems.forEach((skillItem) => {
				observer.observe(skillItem);
			});

			// Image hover animations
			const imageItems = skillsSection.querySelectorAll(".image_item");
			imageItems.forEach((item) => {
				item.addEventListener("mouseenter", () => {
					if (typeof gsap !== "undefined") {
						gsap.to(item, {
							y: -10,
							scale: 1.02,
							duration: 0.4,
							ease: "power2.out",
						});
					} else {
						item.style.transform = "translateY(-10px) scale(1.02)";
						item.style.transition = "transform 0.4s ease";
					}
				});

				item.addEventListener("mouseleave", () => {
					if (typeof gsap !== "undefined") {
						gsap.to(item, {
							y: 0,
							scale: 1,
							duration: 0.4,
							ease: "power2.out",
						});
					} else {
						item.style.transform = "translateY(0) scale(1)";
					}
				});
			});
		}

		// Client Testimonials Carousel
		function initTestimonialsCarousel() {
			console.log("Initializing testimonials carousel...");
			const testimonialsCarousel = $(".testimonials_carousel");

			if (testimonialsCarousel.length > 0) {
				console.log("Testimonials carousel found, initializing...");

				// Destroy existing carousel if it exists
				if (testimonialsCarousel.hasClass("owl-loaded")) {
					testimonialsCarousel.trigger("destroy.owl.carousel");
					testimonialsCarousel.removeClass("owl-loaded owl-drag");
				}

				// Initialize Owl Carousel
				testimonialsCarousel.owlCarousel({
					items: 1,
					loop: true,
					margin: 0,
					nav: false,
					dots: false,
					autoplay: true,
					autoplayHoverPause: true,
					animateOut: "fadeOut",
					animateIn: "fadeIn",
					// navText: [
					// 	'<i class="ri-arrow-left-line"></i>',
					// 	'<i class="ri-arrow-right-line"></i>',
					// ],
					responsive: {
						0: {
							nav: false,
							dots: false,
							margin: 0,
						},
						768: {
							nav: false,
							dots: false,
							margin: 0,
						},
						992: {
							nav: false,
							dots: false,
							margin: 0,
						},
					},
					onInitialized: function () {
						console.log("Testimonials carousel initialized successfully");
						// Add custom styling after initialization
						$(".owl-nav").addClass("testimonial-nav");
						$(".owl-dots").addClass("testimonial-dots");
					},
					onChanged: function (event) {
						// Add smooth transition effects
						const $current = $(event.target).find(
							".owl-item.active .testimonial_item"
						);
						$current.addClass("animate-in");
						setTimeout(() => {
							$current.removeClass("animate-in");
						}, 1000);
					},
				});

				// Custom navigation events
				$(".testimonial-prev").on("click", function () {
					testimonialsCarousel.trigger("prev.owl.carousel");
				});

				$(".testimonial-next").on("click", function () {
					testimonialsCarousel.trigger("next.owl.carousel");
				});
			} else {
				console.log("Testimonials carousel not found");
			}
		}

		// Latest News Section Animation
		function initLatestNewsAnimations() {
			console.log("Initializing latest news animations...");
			const newsSection = document.querySelector(".latest_news");

			if (!newsSection) {
				console.log("Latest news section not found");
				return;
			}

			const blogCards = newsSection.querySelectorAll(".blog_post_card");
			console.log("Found blog cards:", blogCards.length);

			// Enhanced hover effects for blog cards
			blogCards.forEach((card, index) => {
				card.addEventListener("mouseenter", function () {
					this.style.transform = "translateY(-10px)";
					this.style.boxShadow = "0 20px 40px rgba(0, 0, 0, 0.15)";

					const img = this.querySelector(".post_image img");
					const overlay = this.querySelector(".image_overlay");
					const readMore = this.querySelector(".read_more_link i");

					if (img) img.style.transform = "scale(1.05)";
					if (overlay) overlay.style.background = "rgba(139, 154, 139, 0.3)";
					if (readMore) readMore.style.transform = "translateX(5px)";
				});

				card.addEventListener("mouseleave", function () {
					this.style.transform = "translateY(0)";
					this.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.08)";

					const img = this.querySelector(".post_image img");
					const overlay = this.querySelector(".image_overlay");
					const readMore = this.querySelector(".read_more_link i");

					if (img) img.style.transform = "scale(1)";
					if (overlay) overlay.style.background = "rgba(139, 154, 139, 0.1)";
					if (readMore) readMore.style.transform = "translateX(0)";
				});
			});

			// No scroll trigger animations - just static hover effects
			console.log(
				"Latest news hover effects initialized (scroll animations removed)"
			);
		}

		// Initialize all functions when document is ready
		console.log("Document ready, initializing functions...");

		// Initialize functions with slight delays to ensure DOM is ready
		setTimeout(() => {
			if (typeof initHeroAnimations === "function") initHeroAnimations();
			if (typeof initVideoModal === "function") initVideoModal();
			if (typeof initProjectsFilter === "function") initProjectsFilter();
		}, 100);

		setTimeout(() => {
			initHowWeWorkAnimations();
			initSkillsAnimations();
			initTestimonialsCarousel();
			initLatestNewsAnimations();
		}, 300);

		// Initialize counter animations
		initAboutCounterAnimations();
	});
});

function accordianitem(imageNumber) {
	var imageContainer = document.getElementById("image-container");

	// Loop through all the child elements of imageContainer
	for (var i = 0; i < imageContainer.children.length; i++) {
		var image = imageContainer.children[i];

		// Check if the current image's ID matches the clicked image's ID
		if (image.id === "img-" + imageNumber) {
			image.classList.add("active");
		} else {
			image.classList.remove("active");
		}
	}
}

// Homepage accordion start
function expand(target) {
	for (let slide of target.parentNode.children) {
		slide.classList.remove("slide--expanded");
	}
	target.classList.add("slide--expanded");
}
// Homepage accordion end

// <- About Counter Animations ->
function initAboutCounterAnimations() {
	const aboutSection = document.querySelector(".about_us");
	const experienceNumber = document.querySelector(".experience_badge .number");
	const satisfactionPercentage = document.querySelector(
		".satisfaction_badge .percentage"
	);
	const badgeContent = document.querySelector(
		".experience_badge .badge_content"
	);

	if (
		!aboutSection ||
		!experienceNumber ||
		!satisfactionPercentage ||
		!badgeContent
	)
		return;

	// Create timeline for counter animations
	const counterTimeline = gsap.timeline({
		scrollTrigger: {
			trigger: aboutSection,
			start: "top 70%",
			end: "bottom 30%",
			toggleActions: "play none none reverse",
		},
	});

	// Animate badge content container first
	counterTimeline.from(badgeContent, {
		scale: 0.3,
		opacity: 0,
		rotation: -10,
		duration: 1,
		ease: "back.out(1.7)",
	});

	// Animate the experience counter (15+)
	const targetExperience = 15;
	const experienceObj = { value: 0 };

	counterTimeline.to(
		experienceObj,
		{
			value: targetExperience,
			duration: 2,
			ease: "power2.out",
			onUpdate: function () {
				experienceNumber.textContent = Math.round(experienceObj.value) + "+";
			},
		},
		"-=0.5"
	);

	// Animate the satisfaction percentage (95%)
	const targetSatisfaction = 95;
	const satisfactionObj = { value: 0 };

	counterTimeline.to(
		satisfactionObj,
		{
			value: targetSatisfaction,
			duration: 2.5,
			delay: 0.3,
			ease: "power2.out",
			onUpdate: function () {
				satisfactionPercentage.textContent =
					Math.round(satisfactionObj.value) + "%";
			},
		},
		"-=2"
	);

	// Add bounce effect to badge content after counting
	counterTimeline.to(
		badgeContent,
		{
			scale: 1.1,
			duration: 0.2,
			ease: "power2.out",
			yoyo: true,
			repeat: 1,
		},
		"-=0.5"
	);

	// Add scale animation for satisfaction percentage
	counterTimeline.from(
		satisfactionPercentage,
		{
			scale: 0.5,
			opacity: 0,
			duration: 0.8,
			ease: "back.out(1.7)",
		},
		"-=2.7"
	);
}

document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.faq-accordion').forEach(function (accordion) {
		accordion.querySelectorAll('.faq-item').forEach(function (item) {
			item.querySelector('.faq-question').addEventListener('click', function () {
				// Close all items in this accordion
				accordion.querySelectorAll('.faq-item').forEach(function (i) {
					if (i !== item) {
						i.classList.remove('active');
						i.querySelector('.faq-toggle').textContent = '+';
					}
				});
				// Toggle current item
				const isActive = item.classList.contains('active');
				if (isActive) {
					item.classList.remove('active');
					item.querySelector('.faq-toggle').textContent = '+';
				} else {
					item.classList.add('active');
					item.querySelector('.faq-toggle').textContent = '–';
				}
			});
		});
	});
});